<template>
  <v-app style="background-color: #f6f6f6;">
    <footer v-if="!isMobile">
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span>Copyright © {{ year }} eVitalyst. All rights
          reserved

          <a href="https://teksalah.com/" target="_blank">Teksalah</a>
        </span>

    </footer>
    <footer v-if="isMobile">
        <span>Copyright © {{ year }} eVitalyst. All rights
          reserved

          <a href="https://teksalah.com/" target="_blank">Teksalah</a>
        </span>

    </footer>

  </v-app>
</template>

<script>
export default {
  data: () => {
    return {
      year: '',
      isMobile:false,
    }
  },
  created() {
    let date = new Date()
    this.year = date.getFullYear()
    if (window.innerWidth < 769) this.isMobile = true
    else this.isMobile = false
  },
}
</script>

<style>
footer {
  margin-bottom: 0px;
  background-color: black;
  background-color: rgb(245, 250, 248);
  color: black;
  width: 100%;
  text-align: center;
  position: fixed;
  left: 0;
  bottom: 0;
  display: flex;
  text-justify: center;
  justify-content: center;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue